import { useMediaQuery, useTheme } from '@mui/material';

/** Same threshold as the labels module: the persistent rail + editor layout
 * needs at least the `md` breakpoint (900 px) to fit side by side. */
export function useSurveyBuilderDesktopViewport(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
